module.exports = __webpack_public_path__ + "static/img/topbg.da7ca3c1.png";